/**
 * State management for validation that is passed to the ValidatingCallback to allow the management of errors.
 */
var ValidationState = /** @class */ (function () {
    function ValidationState(errors) {
        this._errors = errors;
    }
    /**
     * Check a field for condition.  If the condition is true add the errorMessage to the errors for the field.
     * @param field
     * @param condition
     * @param errorMessage
     */
    ValidationState.prototype.check = function (field, condition, errorMessage) {
        var failed = condition;
        if (typeof condition === 'function') {
            failed = condition();
        }
        if (failed) {
            this.addError(field, errorMessage);
        }
    };
    /**
     * Clear all errors for field, usually called before we call check() on the field.  Can be skipped if we are calling singleCheck() on a field.
     * @param field
     */
    ValidationState.prototype.clearErrors = function (field) {
        this._errors[field] = new Array();
    };
    /**
     * Call clearErrors() and then check() for the field as a convience for fields that only have one check.
     * @param field
     * @param condition
     * @param errorMessage
     */
    ValidationState.prototype.singleCheck = function (field, condition, errorMessage) {
        this.clearErrors(field);
        this.check(field, condition, errorMessage);
    };
    /**
     * Add an error for a field.
     * @param field
     * @param errorMessage
     */
    ValidationState.prototype.addError = function (field, errorMessage) {
        if (this._errors[field] == null) {
            this._errors[field] = new Array();
        }
        this._errors[field].push(errorMessage);
    };
    /**
     * Check rules specified in the rules dictionary of functions
     * @param rules
     * @param fieldsToCheck
     */
    ValidationState.prototype.checkRules = function (rules, fieldsToCheck) {
        var _loop_1 = function (field) {
            if (!fieldsToCheck || fieldsToCheck.find(function (item) { return item === field; })) {
                // Do the check
                var rule = rules[field];
                var errorMessage = rule();
                this_1.clearErrors(field);
                if (errorMessage) {
                    this_1.addError(field, errorMessage);
                }
            }
        };
        var this_1 = this;
        for (var field in rules) {
            _loop_1(field);
        }
    };
    /**
     * Returns the errors found by the validator.
     */
    ValidationState.prototype.errors = function () {
        return this._errors;
    };
    return ValidationState;
}());
export { ValidationState };
//# sourceMappingURL=ValidationState.js.map